"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFound = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const I18n_1 = require("../../../i18n/I18n");
const UI_1 = require("../../UI");
function NotFound() {
    const { t } = I18n_1.useTranslation();
    const { useLink } = UI_1.useUIContext();
    const homepageLink = useLink({ href: "/", children: t("Go To Homepage") });
    return (jsx_runtime_1.jsxs("div", { children: [jsx_runtime_1.jsx("h1", { children: t("Not found") }, void 0),
            jsx_runtime_1.jsx("p", { children: t("The page you are looking for might have been removed, or had its name changed, or is temporarily unavailable") }, void 0),
            jsx_runtime_1.jsx("p", { children: homepageLink }, void 0)] }, void 0));
}
exports.NotFound = NotFound;
//# sourceMappingURL=NotFound.js.map